import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MeetingDetails,CaseData } from '../_models/mcst-model';
import { catchError, filter, map, shareReplay } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class PrivateService {
    private officePermissions$: Observable<any[]> | null = null;
    private officeConfigCache = new Map<string, Observable<any[]>>();

    constructor(private http: HttpClient) { }

    submitCaseForm(formdata: FormData): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/public/offices/mediation/submit-request', formdata, {
          reportProgress: true,
          responseType: 'text'
        });
        return this.http.request(req);
      }

      submitPrivateCaseForm(formdata: FormData): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/internal/offices/mediation/submit-request', formdata, {
          reportProgress: true,
          responseType: 'text'
        });
        return this.http.request(req);
      }

      editCaseForm(office: string, caseId: string | number, formdata: FormData): Observable<HttpEvent<any>> {
        const req = new HttpRequest('PUT', environment.apiUrl + 'api/v1/internal/offices/'+office+'/cases/'+caseId, formdata, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }  

    submitIndautorMeeting(formdata: FormData, type: string): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/internal/meetings/create-meeting/' + type , formdata, {
            reportProgress: true,
            responseType: 'text'
        });
        return this.http.request(req);
    }

    getMeetingDetails(officeName: string, caseId?: string | number): Observable<MeetingDetails[]> {
      if(caseId)
        return this.http.get<MeetingDetails[]>(environment.apiUrl  +'api/v1/internal/meetings/' + officeName +'/case/'+caseId);
      else 
        return this.http.get<MeetingDetails[]>(environment.apiUrl  +'api/v1/internal/meetings/' + officeName);
    }


    getOfficePermissionDetails(): Observable<any[]> {
        if (!this.officePermissions$) {
            this.officePermissions$ = this.http.get<any[]>(environment.apiUrl + 'api/v1/internal/offices/permissions').pipe(
                shareReplay({ bufferSize: 1, refCount: true })
            );
        }
        return this.officePermissions$;
    }

    getOfficeConfiguration(office: string): Observable<any[]> {
        const key = office;
        if (!this.officeConfigCache.has(key)) {
            this.officeConfigCache.set(key, this.http.get<any[]>(environment.apiUrl + 'api/v1/public/offices/configuration?office=' + office).pipe(
                shareReplay({ bufferSize: 1, refCount: true })
            ));
        }
        return this.officeConfigCache.get(key)!;
    }

    getAllcases(office: string): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases');
    }

    getCases(office: string, status: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus='+status);
    }

    getAllCases(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus=ACTIVE&caseStatus=CLOSED');
    }

    getAllPrecases(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus=PENDING_APPROVAL&caseStatus=REJECTED');
    }

    getAllCasesDetailsWithStatus(office: string, status: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus='+status);
    }

    getAllCasesForReports(office: string): Observable<any[]> { 
       return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus=ACTIVE&caseStatus=CLOSED'); 
    }
    getAllPreCasesForReports(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus=PENDING_APPROVAL&caseStatus=REJECTED');
    }

    getCaseDetails(office: string, id: string | number): Observable<CaseData[]> {
      return this.http.get<CaseData[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id);
    }

    getCaseAllAttachmentDetails(office: string, id: string | number): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id+'/files');
    }

    getCaseAllTemplates(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/template-documents');
    }

     getAllStaff(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/mediators');
    }

    updateAlias(formData: FormData): Observable<HttpEvent<{}>> {
       const req = new HttpRequest('PUT', environment.apiUrl +'api/v1/internal/offices/mediators/alias', formData, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    uploadTemplates(office: string, formData: FormData): Observable<HttpEvent<{}>> {
       return this.http.post<any>(environment.apiUrl +'api/v1/internal/offices/'+office+'/template-documents', formData, {
        reportProgress: true,
        observe: 'events'
      });
    }

    updateFile(office: string, templateId: string | number, formData: FormData): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('PUT', environment.apiUrl +'api/v1/internal/offices/'+office+'/template-documents/'+templateId, formData, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    downloadAttachmentZip(office: string, id: string | number): Observable<HttpEvent<Blob>> {
      const req = new HttpRequest('POST', environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+id+'/files/zip', {
        reportProgress: true,
        responseType: 'blob'
      });
      return this.http.request(req);
    }

    getCaseAttachmentDetails(office: string, id: string | number, fileId: string | number): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id+'/files/'+fileId);
    }

    uploadAttachment(office: string, id: string | number, formData: FormData): Observable<HttpEvent<{}>> {
       return this.http.post<any>(environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+id+'/files', formData, {
        reportProgress: true,
        observe: 'events'
      });
    }


    downloadZipFromServer(office: string, ID: string | number): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+ID+'/files/zip', { 
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }

    downloadFileFromServer(office: string, ID: string | number, fileId: string | number): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + ID + '/files/' + fileId, { // Make sure environment.apiUrl points to your download endpoint
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }

    downloadTemplate(office: string, fileId: string | number): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + fileId, { // Make sure environment.apiUrl points to your download endpoint
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }


  generateTemplate(office: string, fileId: string, caseId: string): Observable<HttpResponse<Blob>> {
  return this.http.post(
    environment.apiUrl + `api/v1/internal/offices/${office}/template-documents/${fileId}/generate/${caseId}`,
    null, // The request body is null or an empty object since the data is in the URL
    {
      observe: 'response',
      responseType: 'blob'
    }
  );
}

  getTemplateByID(office: string, templateID: string | number): Observable<any[]> {
       return this.http.get<any[]>(environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + templateID);
  }

  deleteTemplate(office: string, id: string | number, templateID: string | number): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + templateID, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
  }

   
 deleteAttachment(office: string, id: string | number, fileId: string | number): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + id + '/files/' + fileId, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }


    deleteCase(office: string, caseId: string | number): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + caseId, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    updateCaseStatus(office: string, id: string | number, data: FormData): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('PUT', environment.apiUrl + 'api/v1/internal/offices/'+office+'/cases/'+id+'/status', data, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    getOfficeAudit(office: string): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}api/v1/internal/offices/auditlog?office=${office}`);
    }


    /**
     * Searches for custom outcomes based on field criteria for a specific office
     * @param office - The office identifier
     * @param fieldName - The name of the field to search by
     * @param searchValue - The value to search for
     * @returns Observable of the HTTP response
    */

    getCustomOutcome(office: string, fieldName: string, searchValue: string): Observable<HttpEvent<string[]>> {
      let myFormData = new FormData();
      myFormData.append('fieldName', fieldName);
      myFormData.append('searchValue', searchValue);
        const req = new HttpRequest('POST', environment.apiUrl + `api/v1/internal/offices/${office}/fields/search`  , myFormData, {
            reportProgress: true,
            responseType: 'text'
        });
        // return this.http.request(req);
        return this.http.request(req).pipe(
            filter(event => event instanceof HttpResponse),
            map((event: HttpResponse<any>) => {
              // Extract the body
              const responseBody = event.body;
              // Check if it's a string that needs parsing
              if (typeof responseBody === 'string') {
                try {
                  return JSON.parse(responseBody);
                } catch (e) {
                  console.error('Error parsing response:', e);
                  return [] as string[];
                }
              }
        // If it's already parsed or null/undefined
        return responseBody || [] as string[];
        })
      );
    }

    getMediatorList(office: string): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/mediators');
    }

    getCaseTitleDetails(office: string, caseId: string | number): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+caseId+'/summary');
    }

    // Quicksight Integration
    getQuicksightEmbedUrl(office: string): Observable<{ embedUrl: string }> {
      return this.http.get<{ embedUrl: string }>(environment.apiUrl + `api/v1/internal/quicksight/${office}/embed-url`);
    }
    

}


